import React from 'react';

const Footer = () => {
    return (<footer className="sticky-footer" style={{display:'none'}}>
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright © Your Website 2018</span>
            </div>
        </div>
    </footer>)
}

export default Footer;